module.exports = __webpack_public_path__ + "static/media/logo-habix-negativo.31aecf4d.svg";